module.exports = "/_next/static/images/30cf7f050e68e32ac360bae688d12081-double-card@1x.png.webp";